export default function initializeSingleProduct() {
    document.querySelectorAll('.single-product-container').forEach(function (sp) {
        new SingleProduct(sp);
    });
}

class SingleProduct {

    constructor(sp) {
        this.sp = sp;
        this.init();
        this.collapse();
        this.updatePrice();
    }

    init() {
        const buttons = this.sp.querySelectorAll('.quantity-minus, .quantity-plus');

        const inputs = this.sp.querySelectorAll('.quantity');

        buttons.forEach(button => {
            button.addEventListener('click', () => {
                const targetInput = document.getElementById(button.getAttribute('data-target'));
                const currentValue = parseInt(targetInput.value) || 0;

                if (button.classList.contains('quantity-plus')) {
                    targetInput.value = currentValue + 1;
                    targetInput.closest('.single-product-container__additional-product__list__item').classList.remove('empty');
                } else if (button.classList.contains('quantity-minus')) {
                    if (currentValue > 0) {
                        targetInput.value = currentValue - 1;
                    }
                    if(currentValue === 1) {
                        targetInput.closest('.single-product-container__additional-product__list__item').classList.add('empty');
                    }
                }

                const changeEvent = new Event('change', { bubbles: true });
                targetInput.dispatchEvent(changeEvent);
            });
        });

        inputs.forEach(input => {
            input.addEventListener('input', () => {
                const currentValue = parseInt(input.value) || 0;
                if (currentValue <= 0) {
                    input.value = 0;
                    input.closest('.single-product-container__additional-product__list__item').classList.add('empty');
                } else if (currentValue > 99) {
                    input.value = 99;
                    input.closest('.single-product-container__additional-product__list__item').classList.remove('empty');
                } else{
                    input.closest('.single-product-container__additional-product__list__item').classList.remove('empty');
                }
            });
            if (input.value === '0') {
                input.closest('.single-product-container__additional-product__list__item').classList.add('empty');
            }
        });
    }

    collapse(){
        const title = this.sp.querySelector(".single-product-container__additional-product__title");
        const container = this.sp.querySelector(".single-product-container__additional-product");

        title.addEventListener("click", function() {
            if (container.classList.contains("active")) {
                container.classList.remove("active");
            } else {
                container.classList.add("active");
            }
        });
    }

    updatePrice() {
        const priceElement = this.sp.querySelector('.woocommerce-Price-amount.amount');
        if (!priceElement) return;

        const productPrice = parseFloat(priceElement.textContent.replace(/[^\d.-]/g, ''));
        const customCurrency = priceElement.querySelector('.custom-currency').textContent;

        this.sp.querySelectorAll('form.cart').forEach(cartForm => {
            cartForm.addEventListener('change', () => {
                const selectedRadio = cartForm.querySelector('input[type="radio"]:checked');
                const selectedInputs = cartForm.querySelectorAll('input[type="number"]');

                if (selectedRadio || selectedInputs.length > 0) {
                    this.calculateAndUpdatePrice(selectedRadio, selectedInputs, productPrice, customCurrency, priceElement);
                }
            });

            const selectedRadio = cartForm.querySelector('input[type="radio"]:checked');
            const selectedInputs = cartForm.querySelectorAll('input[type="number"]');
            this.calculateAndUpdatePrice(selectedRadio, selectedInputs, productPrice, customCurrency, priceElement);
        });
    }

    calculateAndUpdatePrice(selectedRadio, selectedInputs, productPrice, customCurrency, priceElement) {
        let sum = 0;

        if (selectedRadio && selectedRadio.dataset.price) {
            sum += parseFloat(selectedRadio.dataset.price);
        }

        selectedInputs.forEach(input => {
            const inputPrice = parseFloat(input.dataset.price);
            const inputValue = parseInt(input.value);
            sum += inputPrice * inputValue;
        });

        const updatedPrice = productPrice + sum;
        priceElement.innerHTML = `${updatedPrice.toFixed(2).replace(/\.00$/, '')} <span class="custom-currency">${customCurrency}</span>`;
    }
}
